import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay } from 'swiper/modules';
import { Col, Container, Row } from "react-bootstrap";
import "./Testimonial.css";

const Testimonial = () => {
  return (
    <div className="testimonial-containers">
      <Container>
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          className="mySwiper"
        >

          {/* SLIDE 1 */}
          <SwiperSlide>
            <Row>
              <Col style={{ position: 'relative' }}>
                <div className="quote-img">
                  <img
                    src="https://voicer.softali.net/wordpress/voicer/images/quote.png"
                    alt=""
                  />
                </div>
                <div className="shortcode_vc_column_text review-item-content">
                  <h2>
                    <span>What Our Customers Say</span>
                  </h2>
                  <p className="p--lg review-item-text">
                    VDNI helped me scale my music distribution and reach global
                    listeners faster than any other platform. Amazing support!
                  </p>
                  <p className="review-item-author-name">
                    – Arjun Mehra
                  </p>
                </div>
              </Col>

              <Col>
                <div className="vc_single_image-wrapper">
                  <img
                    src="/Images/testi1.jpg"
                    alt=""
                    className="vc_single_image-img"
                  />
                </div>
              </Col>
            </Row>
          </SwiperSlide>

          {/* SLIDE 2 */}
          <SwiperSlide>
            <Row>
              <Col style={{ position: 'relative' }}>
                <div className="quote-img">
                  <img
                    src="https://voicer.softali.net/wordpress/voicer/images/quote.png"
                    alt=""
                  />
                </div>
                <div className="shortcode_vc_column_text review-item-content">
                  <h2>
                    <span>What Our Customers Say</span>
                  </h2>
                  <p className="p--lg review-item-text">
                    My streams increased and my audience expanded massively.  
                    VDNI is the best choice for independent artists.
                  </p>
                  <p className="review-item-author-name">
                    – Sarah Collins
                  </p>
                </div>
              </Col>

              <Col>
                <div className="vc_single_image-wrapper">
                  <img
                    src="/Images/testi2.jpg"
                    alt=""
                    className="vc_single_image-img"
                  />
                </div>
              </Col>
            </Row>
          </SwiperSlide>

          {/* SLIDE 3 */}
          <SwiperSlide>
            <Row>
              <Col style={{ position: 'relative' }}>
                <div className="quote-img">
                  <img
                    src="https://voicer.softali.net/wordpress/voicer/images/quote.png"
                    alt=""
                  />
                </div>
                <div className="shortcode_vc_column_text review-item-content">
                  <h2>
                    <span>What Our Customers Say</span>
                  </h2>
                  <p className="p--lg review-item-text">
                    The tools and support offered by VDNI accelerated my growth
                    in ways I didn’t expect. Highly recommended!
                  </p>
                  <p className="review-item-author-name">
                    – Michael R.
                  </p>
                </div>
              </Col>

              <Col>
                <div className="vc_single_image-wrapper">
                  <img
                    src="/Images/testi3.jpg"
                    alt=""
                    className="vc_single_image-img"
                  />
                </div>
              </Col>
            </Row>
          </SwiperSlide>

        </Swiper>
      </Container>
    </div>
  );
};

export default Testimonial;
